import { useMobileShellPadded } from './MobileShellPaddingContext';

/**
 * Horizontal padding for page content when the mobile shell is flushed
 * (Search / Collection / etc.). Zero when AppLayout still applies `px={4}`.
 */
export function useMobilePageGutter(): number {
  return useMobileShellPadded() ? 0 : 4;
}
